import type { OpxHostAppDetailType } from '../types/OpxHostAppDetailType';

let OpxHostAppDetail: Partial<OpxHostAppDetailType> = {};

export const getOpxHostAppDetailStore = () => OpxHostAppDetail;

export const updateOpxHostAppDetailStore = (hostAppDetail: OpxHostAppDetailType) => {
    OpxHostAppDetail = hostAppDetail;
};
